/* eslint-disable max-len */
import { ERRORS } from '../constants';

export default {
  ERRORS: {
    [ERRORS.INVALID_PROZIS_POINTS]:
      'Ops, i ProzisPoints che vuoi condividere con il corriere non sono più disponibili. Si prega di riprovare.'
  },
  MESSAGES: {
    ANSWERED_SURVEY:
      'Abbiamo già ricevuto il tuo feedback relativo alla consegna dell\'ordine {code}. \n\rSiamo ansiosi di sapere la tua opinione riguardo le prossime esperienze. 👍',
    AVAILABLE_POINTS: 'ProzisPoints disponibili:',
    DO_NOT_SHARE_YOUR_POINTS: 'Non condividere ProzisPoints',
    EXPERIENCE_EVALUATION: 'VALUTA L\'ESPERIENZA DI CONSEGNA',
    FEEDBACK_HERE: 'Lascia il tuo feedback qui',
    FEEDBACK_THANKS:
      'Grazie per il tuo feedback sul servizio di consegna PROZIS NOW. \n\rPromettiamo di prenderlo sul serio! 💪',
    HOW_BE_BETTER:
      'Dicci cosa stiamo facendo bene e in cosa possiamo migliorare',
    MORE_TO_SAY: 'IMPROVE OURSELVES',
    SAY_HELP_TO_COURIER: 'Vuoi ringraziare il corriere?',
    SAY_HELP_TO_USER: 'Vuoi ringraziare chi ha consegnato il tuo ordine?',
    SHARE_YOUR_POINTS:
      'Condividi i tuoi ProzisPoints con {name}. La tua mancia sarà apprezzata. 😉',
    TIP_COURIER: 'Lascia una mancia a {name}',
    TIP_USER: 'Lascia una mancia a {name}'
  }
};
